import Loader from "./src/components/Loader";
import LoadWrapper from "./src/components/LoadWrapper";

export default Loader;
export { LoadWrapper };
